import EditableFormattedMessage from "./EditableFormattedMessage";
import messagesData from "../lang/preferences";

export default function EmotionalityDefinitionsPage({ messages, locale, updateMessage, graph, keyPage, code, datePassed }) {
  return (
    <div className="PageCharts-chart">
      <div className="header-logo-box">
        {/* Add your logo here if needed */}
      </div>
      <div className="report-alt-page">
        <h1>
          <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={graph.title} messages={messages} updateMessage={updateMessage} />
          <span className="inline font-16">
            {" "}
            - <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="DEFINITIONS" messages={messages} updateMessage={updateMessage} />
          </span>
        </h1>
        <br />
        <table className="scope-table-fullwidth">
          <tbody>
            {/* Serenity */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SERENITY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SERENITY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Anxiety */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_ANXIETY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_ANXIETY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Negative Affect */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_NEGATIVEAFFECT" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_NEGATIVEAFFECT_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Self-Consciousness */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SELFCONSCIOUSNESS" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SELFCONSCIOUSNESS_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Irritability */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_IRRITABILITY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_IRRITABILITY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="pdf-footer">
        <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="PAGE" messages={messages} updateMessage={updateMessage} /> {keyPage + 1}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="CANDIDATE" messages={messages} updateMessage={updateMessage} />
          </b>
        </div>{" "}
        {code}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="TEST_DATE" messages={messages} updateMessage={updateMessage} />
          </b>{" "}
          {datePassed}
        </div>
      </div>
    </div>
  );
}